import axios from 'axios'

const AxiosApi = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api' : 'https://backend.portal.rgsaude.com.br/api'
});

AxiosApi.interceptors.request.use(request => {
    const accessToken = localStorage.getItem('RgSaude@Token');

    if (accessToken) {
        request.headers.Authorization = `Bearer ${accessToken}`;
    }

    return request;
})

export default AxiosApi;